import React from 'react'
import {Grid, Paper} from '@material-ui/core';
import PropTypes from 'prop-types'
import {withStyles, withTheme} from '@material-ui/styles';
import clsx from 'clsx';
import Title from './Title';
import useNodeTopPosition from 'hooks/useNodeTopPosition';

const style = theme => ({
    root: {
        '&>*': {
            marginBottom: theme.spacing(4),
        }
    },
    fullHeight: {
        height: '100%',
    },
    paper: theme.components.paper,
    progressItem: {
        top: 100,
        position: 'sticky',
        zIndex: theme.zIndex.appBar - 1,
    }
})

function Workspace(
    {
        title,
        className,
        children,
        classes,
        render,
        fullHeight
    }) {

    const [nodeRef] = useNodeTopPosition()

    return (
        <Grid
            ref={nodeRef}
            container
            direction='column'
            className={clsx({
                    [classes.fullHeight]: fullHeight
                },
                classes.root,
                className
            )}
        >
            {title &&
            <Grid item>
                <Title>
                    {title}
                </Title>
            </Grid>}

            {
                render &&
                <Grid item>
                    {render}
                </Grid>
            }
            {
                children &&
                <Grid item>
                    <Paper className={classes.paper}>
                        {children}
                    </Paper>
                </Grid>
            }
        </Grid>
    )
}

Workspace.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.any,
    render: PropTypes.any,
    fullHeight: PropTypes.bool,
}

Workspace.propDefault = {
    fullHeight: true,
}

export default withTheme(withStyles(style)(Workspace));
